import React from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "../../UIElements/Icon";

const EmptyBusinessState = ({ onRetry, isLoading }) => {
  const navigate = useNavigate();

  const handleCreateBusiness = () => {
    navigate("/menu/stores/create/address");
  };

  return (
    <div className="flex min-h-[400px] items-center justify-center">
      <div className="mx-auto max-w-md p-6 text-center">
        <div className="bg-muted mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full">
          <Icon name="Building" className="text-muted-foreground h-8 w-8" />
        </div>

        <h3 className="text-foreground mb-2 text-lg font-semibold">
          No Businesses Found
        </h3>

        <p className="text-muted-foreground mb-6">
          To get started with the dashboard, you need to create your first
          business. Click the button below to begin.
        </p>

        <div className="space-y-3">
          <button
            onClick={handleCreateBusiness}
            className="bg-primary text-primary-foreground hover:bg-primary/90 flex w-full items-center justify-center space-x-2 rounded-md px-4 py-2 transition-colors"
          >
            <Icon name="Plus" className="h-4 w-4" />
            <span>Create My First Business</span>
          </button>

          <button
            onClick={onRetry}
            disabled={isLoading}
            className="bg-muted text-muted-foreground hover:bg-muted/80 w-full rounded-md px-4 py-2 transition-colors disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isLoading ? (
              <div className="flex items-center justify-center space-x-2">
                <div className="border-muted-foreground h-4 w-4 animate-spin rounded-full border-b-2"></div>
                <span>Refreshing...</span>
              </div>
            ) : (
              "Refresh Page"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmptyBusinessState;
